/** @jsxImportSource @emotion/react */
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { DeliveryRulesSelector } from "./delivery-rules-modal/DeliveryRulesSelector";
import { useGetDeliveryGroups } from "../../service/api";
import { useSelector } from "react-redux";
import * as authSelectors from "../../module/auth/authSelectors";
import { SpinnerBlock } from "../common/Spinner";
import { DeliveryRuleComponent } from "./DeliveryRuleComponent";
import { DeliveryRulesPlaceholder } from "./DeliveryRulesPlaceholder";
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import { CardBody } from "../../components/page-skeleton/CardBody";
import { cardBottomPadding } from "../../style-util";
import { useHandleFetchError } from "../../error-handler";

export const DeliveryRulesList = () => {
  const organization = useSelector(authSelectors.selectedOrganizationKeyName);
  const {
    data: deliveryRuleGroups,
    isLoading,
    error: listDeliveryRuleGroupsError,
  } = useGetDeliveryGroups(organization);

  useHandleFetchError(listDeliveryRuleGroupsError);

  if (isLoading) {
    return <SpinnerBlock />;
  }

  return (
    <PageWrapper>
      <CardContainer>
        <PageHeader
          title="Delivery rule groups"
          subtitle="Create, edit and manage delivery rules for your delivery service"
        >
          <DeliveryRulesSelector />
        </PageHeader>
        <CardBody css={cardBottomPadding}>
          {deliveryRuleGroups &&
            (deliveryRuleGroups.length === 0 ? (
              <DeliveryRulesPlaceholder />
            ) : (
              deliveryRuleGroups.map((group) => (
                <DeliveryRuleComponent key={group.id} group={group} />
              ))
            ))}
        </CardBody>
      </CardContainer>
    </PageWrapper>
  );
};
